import React from "react";
import { Container, Table } from "react-bootstrap";

function ComplianceOffice() {
  return (
    <>
      <section className="complianceOfficer">
        <Container className="complianceOfficerDataTable">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.N.</th>
                <th>Contact Name</th>
                <th>Exchance</th>
                <th>Contact Number</th>
                <th>Contact Mail</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Shri Gian Singh</td>
                <td>NSE</td>
                <td>9810312444</td>
                <td>opg@opgsecurities.com</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Mr. Gian Singh</td>
                <td>BSE & MSEI</td>
                <td>9599194534</td>
                <td>opg@opgsecurities.com</td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </section>
    </>
  );
}

export default ComplianceOffice;
